import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Badge, Box, Hidden, IconButton, Toolbar, makeStyles, Typography, colors, Grid } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import LogoHome from 'assets/images/logoTI.svg';
import LogoTiBlanco from 'assets/logo ti blanco.svg';
import LogoDashBlanco from 'assets/logo dashboard blanco.svg';
import logoCentro from 'assets/images/LogoCM.svg';
import { Menu, MenuOpen } from '@material-ui/icons/';

const useStyles = makeStyles(theme => ({
    root: {
        background: '#2d3239',
        color: '#ffffff'
    },
    bold: {
        //background: '#ffffff',
        //height: '60px'
    },
    avatar: {
        width: 60,
        height: 60
    },
    btnAceptar: {
        color: '#515E63'
    }
}));
const clickLogout = event => {
    localStorage.removeItem('token');
    localStorage.removeItem('rol');
    localStorage.removeItem('user');
    localStorage.removeItem('filtros');
    //this.props.history.push('/auth/login');
    window.location.replace('/');
    //window.location.reload(true)
};
const TopBar = ({ className, onMobileNavOpen, openNavDesktop, onOpenNavDesktop, usuario, rutasUsuario, ...rest }) => {
    const nombre_user = usuario[0].nombre
        ? usuario[0].nombre + ' ' + usuario[0].apaterno + ' ' + (usuario[0].amaterno ? usuario[0].amaterno : '')
        : ' ';
    const classes = useStyles();
    const [notifications] = useState([]);

    return (
        <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
            <Toolbar>
                <Hidden mdDown>
                    <Grid container justifyContent="space-between" alignContent="center" alignItems="center">
                        <Grid item xs={9} container style={{ margin: 'auto' }}>
                            <Grid item xs={2}>
                                <img alt="Logo" src={LogoDashBlanco} height="60px" style={{ margin: 'auto' }} />
                            </Grid>
                            <Grid item xs={3} style={{display:'flex',alignItems:'center', marginLeft:"24px"}}>
                                <IconButton size='large' color="inherit" onClick={onOpenNavDesktop} title='Abrir/Cerrar menu'>
                                    {openNavDesktop ? <MenuOpen /> : <Menu />}
                                </IconButton>
                            </Grid>
                        </Grid>
                        {/* <Grid item xs style={{ margin: 'auto', textAlign: 'center' }}>
                            <img alt="Logo" src={logoCentro} height="30px" />
                        </Grid> */}
                        <Grid item xs={3} style={{ textAlign: 'right', display:'flex',flexDirection:'row', justifyContent:'center', alignItems:'center' }}>
                            <Typography>
                                {nombre_user}
                            </Typography>
                            <IconButton color="inherit" onClick={clickLogout} title='Cerrar Sesión'>
                                <InputIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Hidden>
                <Hidden lgUp>
                    <IconButton color="inherit" onClick={onMobileNavOpen}>
                        <MenuIcon />
                    </IconButton>
                    <img alt="Logo" src={LogoHome} height="30px" />
                </Hidden>
            </Toolbar>
        </AppBar>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func
};

export default TopBar;
